import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SITE } from "@/lib/site";

export default function LegalPage({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <header className="border-b border-white/5 backdrop-blur-xl bg-black/60 sticky top-0 z-20">
        <div className="max-w-5xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 group">
            <span
              aria-hidden
              className="block h-9 w-9 rounded-md"
              style={{
                backgroundImage: `url(${SITE.logo})`,
                backgroundSize: "550%",
                backgroundPosition: "center 28%",
                backgroundRepeat: "no-repeat",
              }}
            />
            <span className="font-serif text-lg text-white group-hover:text-rolex-light transition-colors">
              {SITE.brand}
            </span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm text-gray-400 hover:text-white transition-colors"
          >
            <ArrowLeft className="h-4 w-4" />
            Back to website
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="text-[11px] uppercase tracking-[0.28em] text-rolex-light mb-5">
          Legal
        </div>
        <h1 className="font-serif text-5xl md:text-6xl font-light leading-[1.05]">
          {title}
        </h1>
        <p className="mt-4 text-sm text-gray-500 font-light">
          Last updated: {lastUpdated}
        </p>

        <article className="prose-legal mt-12 space-y-8">{children}</article>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl md:text-3xl text-white font-light mb-4">
        {title}
      </h2>
      <div className="text-[15px] text-gray-400 leading-relaxed font-light space-y-4">
        {children}
      </div>
    </section>
  );
}
